"use strict";

function assert(condition, message = "'condition' is falsy.", ErrorClass = Error) {
  if (!condition) {
    throw new ErrorClass(message);
  }
}
function assertUnreachable(_value) {
  throw new Error("Statement should be unreachable");
}
function checkUnreachable(_value) {}
function assertTypeEquality() {}
export { assert, assertTypeEquality, assertUnreachable, checkUnreachable };
//# sourceMappingURL=errors.mjs.map
